import React from 'react';
import ResumeDownload from './ResumeDownload';

export interface ExperienceProps {}

const Experience: React.FC<ExperienceProps> = (props) => {
    return (
        <div className="site-page-content">
            <h1>Experience</h1>
            <h3>Software Development, Hackathons, and Competitions</h3>
            <br />
            <p>
                Below are some of my work experiences, hackathons, and achievements in competitions.
            </p>
            <br />
            <ResumeDownload />
            <div style={styles.headerContainer}>
                <div style={styles.header}>
                    <div style={styles.headerRow}>
                        <h1>Juice</h1>
                        <a
                            rel="noreferrer"
                            target="_blank"
                            href={'https://juice.hackclub.com'}
                        >
                            <h4>https://juice.hackclub.com</h4>
                        </a>
                    </div>
                    <br />
                    <div style={styles.headerRow}>
                        <h3>Operations & Support</h3>
                        <b>
                            <p>Spring 2025</p>
                        </b>
                    </div>
                </div>
            </div>
            <div className="text-block">
                <p>
                    Helped out behind the scenes with Juice, a super cool Hack Club program where high schoolers from all over the world 
                    spent two months building original, languageless video games for Steam. It all wrapped up with an in-person popup exhibit 
                    in Shanghai. I was mostly on the ops and support side — reviewing hours that participants logged, answering questions in the Juice Slack, 
                    and making sure everyone had what they needed to keep building. I also handled reimbursements for travel and project costs, 
                    and added a few small features to the Juice website to help things run more smoothly. It was awesome getting to support 
                    such a creative and global group of builders.
                </p>
                <br />
            </div>
            <div style={styles.headerContainer}>
                <div style={styles.header}>
                    <div style={styles.headerRow}>
                        <h1>Brilliant</h1>
                        <a
                            rel="noreferrer"
                            target="_blank"
                            href={'https://brilliant.org/home/'}
                        >
                            <h4>https://brilliant.org</h4>
                        </a>
                    </div>
                    <br />
                    <div style={styles.headerRow}>
                        <h3>Software Developer Intern</h3>
                        <b>
                            <p>Summer 2024</p>
                        </b>
                    </div>
                </div>
            </div>
            <div className="text-block">
                <p>
                    During my internship at Brilliant, I have had the opportunity to work on innovative educational technologies and collaborate with a talented team. I have contributed to various projects, including developing new features for Brilliant's learning platform and optimizing existing systems for better performance.
                </p>
                <br />
                <ul style={styles.experienceList}>
                    
                </ul>
                <br />
            </div>
            <div style={styles.headerContainer}>
                <div style={styles.header}>
                    <div style={styles.headerRow}>
                        <h1>Hack Club</h1>
                        <a
                            rel="noreferrer"
                            target="_blank"
                            href={'https://hackclub.com'}
                        >
                            <h4>https://hackclub.com</h4>
                        </a>
                    </div>
                    <br />
                    <div style={styles.headerRow}>
                        <h3>Member</h3>
                        <b>
                            <p>Summer 2024</p>
                        </b>
                    </div>
                </div>
            </div>
            <div className="text-block">
                <p>
                    Hack Club is a global community of high school coders and creators, designed to empower students to build real-world projects, collaborate,
                    and learn together. Whether you're a beginner or experienced developer, Hack Club provides an open space for exploring technology, developing coding skills,
                    and making meaningful connections with peers. 
                    With access to workshops, resources, and events like hackathons, Hack Club encourages students to turn their ideas into reality and share them with the world.
                    As a proud Hack Club member,
                    I’m excited to contribute to this vibrant community and help foster a culture of creativity and innovation in coding.
                </p>
                <br />
            </div>
            <div style={styles.headerContainer}>
                <div style={styles.header}>
                    <div style={styles.headerRow}>
                        <h1>Apple</h1>
                        {/* Add commentMore actions */}
                    </div>
                    <br />
                    <div style={styles.headerRow}>
                        <h3>Software Developer Intern</h3>
                        <b>
                            <p>Fall 2024</p>
                        </b>
                    </div>
                </div>
            </div>
            <div className="text-block">
                <p>
                    My time as a Software Developer at Apple, though brief, was an incredible learning experience.
                    I got the opportunity to work alongside talented engineers and contribute to real-world projects, even on a small scale. 
                    From debugging to implementing minor features, 
                    I gained a deeper understanding of how large-scale software development works and how Apple delivers such polished products. 
                    While my role was limited, 
                    the experience gave me insight into cutting-edge technology and inspired me to keep growing as a developer.
                </p>
                <br />
            </div>
            <div style={styles.headerContainer}>
                <div style={styles.header}>
                    <div style={styles.headerRow}>
                        <h1>Ebhar Misr</h1>
                        <a
                            rel="noreferrer"
                            target="_blank"
                            href={'https://ebharmisr.com/en/home/'}
                        >
                            <h4>https://ebharmisr.com</h4>
                        </a>
                    </div>
                    <br />
                    <div style={styles.headerRow}>
                        <h3>Competition</h3>
                        <b>
                            <p>Summer 2022</p>
                        </b>
                    </div>
                </div>
            </div>
            <div className="text-block">
                <p>
                    Targeted towards Teens with diverse interests in music, art, science, technology, and singing.
                    Each year, 20 participants are chosen to attend a camp that enhances their soft skills.
                    Additionally, you'll have the opportunity to tour prestigious Egyptian universities.
                    I was one of the selected students chosen to participate after successfully competing in their rigorous competition process.
                </p>
                <br />
            </div>
        </div>
    );
};

const styles: StyleSheetCSS = {
    header: {
        flexDirection: 'column',
        justifyContent: 'space-between',
        width: '100%',
    },
    skillRow: {
        flex: 1,
        justifyContent: 'space-between',
    },
    skillName: {
        minWidth: 56,
    },
    skill: {
        flex: 1,
        padding: 8,
        alignItems: 'center',
    },
    progressBar: {
        flex: 1,
        background: 'red',
        marginLeft: 8,
        height: 8,
    },
    hoverLogo: {
        height: 32,
        marginBottom: 16,
    },
    headerContainer: {
        alignItems: 'flex-end',
        width: '100%',
        justifyContent: 'center',
    },
    hoverText: {
        marginBottom: 8,
    },
    indent: {
        marginLeft: 24,
    },
    headerRow: {
        justifyContent: 'space-between',
        alignItems: 'flex-end',
    },
    row: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    experienceList: {
        fontFamily: 'inherit', 
        fontSize: 'inherit',  
        lineHeight: 'inherit',
        color: 'inherit',
    },
};

export default Experience;